import './pdf-overview-screen.scss'

import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

import { ConditionReport, ConditionReportPDFGenerator, conditionReportSelectors } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { PDFViewer, SearchFeatured } from '@skinsoft/ui';

import { CLOSE_PDF_OVERVIEW_TOPIC } from '../../busTopics';
import { PDFProgressBar } from './pdf-progress-bar';
import { SignerInputCard } from '../component/signature-module/signer-input-card';
import { DISPLAY_ALERT_TOPIC } from '@skinsoft/bus/src/busTopics';

@Component({
    components: {
        sPdfProgressBar: PDFProgressBar,
        sPdfViewer: PDFViewer,
    },
    props: ['conditionReport', 'searchFeatured'],
    template: require('./pdf-overview-screen.html')
})
export class PDFOverviewScreen extends ReactiveVue {

    private $conditionReportPDFGenerator: ConditionReportPDFGenerator

    public conditionReport: ConditionReport;
    public pdfFile: File = null as any;
    public pdfFileUrl: string = "";

    private searchFeatured: SearchFeatured;
    private pdfReady = false;

    private backIcon = faArrowLeft;

    private closePdfOverviewScreen() {
        this.emitOnBus(CLOSE_PDF_OVERVIEW_TOPIC)
    }

    private onFileUploaded(event) {
        this.pdfFile = event.target.files[0]
    }

    private get fileName() {
        return `${conditionReportSelectors.referenceNumber(this.conditionReport)}.pdf`
    }

    @Watch('searchFeatured', { immediate: true })
    private onSearchFeaturedChange() {
        this.$conditionReportPDFGenerator.generatePDF(this.conditionReport, this.searchFeatured, (blob) => {
            this.pdfReady = true;
            this.pdfFile = blob
            this.pdfFileUrl = window.URL.createObjectURL(blob)
        })
        .catch(e => {
            const alertPayload = {
                message: this.$t('pdfDocument.generationFailureAlert'),
                variant: 'danger'
            };
            this.emitOnBus(DISPLAY_ALERT_TOPIC, alertPayload)
        })

    }
}